

























































import { getSupportTopics, searchSupportArticles } from '@/services/cms'
import { Component, Vue } from 'vue-property-decorator'

type SupportArticle = {
  id: number
  attributes: {
    title: string
    description: string
    url_id: string
    createdAt: string
    updatedAt: string
    publishedAt: string
    [key: string]: any
  }
}

type Topic = {
  id: number
  attributes: {
    name: string
    createdAt: string
    updatedAt: string
    is_topic: boolean
    support_articles: {
      data: SupportArticle
    }
  }
}

@Component({
  metaInfo: {
    title: 'Support',
  },
})
export default class Support extends Vue {

  loading = false
  loadingSearch = false
  topics: Topic[] = []
  query = ''
  searchResults = []

  async mounted() {
    this.loading = true
    this.topics = await getSupportTopics()
    this.loading = false
  }

  // Debounce search
  searchTimeout: any = null

  async search(val: any) {
    this.loadingSearch = true
    const nonEmpty = val && val.length

    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(async () => {
      this.searchResults = await searchSupportArticles(nonEmpty ? val : null)
      this.loadingSearch = false
    }, nonEmpty ? 250 : 0)
  }

  filter(item: any, queryText: string, itemText: string) {
    // Match title or description
    return item.attributes.title.toLowerCase().includes(queryText.toLowerCase()) ||
      item.attributes.description.toLowerCase().includes(queryText.toLowerCase())
  }

  openArticle(article: SupportArticle) {
    this.$router.push({
      name: 'supportArticle',
      params: {
        articleId: article.attributes.url_id
      }
    })
  }
}
